import { map } from 'ramda';
import React, { FC } from 'react';
import { useUploadingFiles } from '../../../../utils/hooks/useFilesUploader';
import { IOuter } from './FilesList.types';
import { UploadingItem } from './UploadingItem';

const HIDE_ITEMS_THRESHOLD = 10;

export const FilesList: FC<IOuter> = ({ onOpenDestinationFolder, currentFolder }) => {
  const { uploadingFiles, filesCount } = useUploadingFiles();
  const shouldStayVisible = filesCount <= HIDE_ITEMS_THRESHOLD;

  return (
    <>
      {map(
        (item) => (
          <UploadingItem
            item={item}
            key={item.id}
            onOpenDestinationFolder={onOpenDestinationFolder}
            currentFolder={currentFolder}
            shouldStayVisible={shouldStayVisible}
          />
        ),
        uploadingFiles,
      )}
    </>
  );
};
